export default {
  common: {
    welcome: 'Välkommen tillbaka!',
    close: 'Stäng',
    signOut: 'Logga ut',
    signIn: 'Logga in',
    home: 'Hem',
    products: 'Produkter',
    producers: 'Producenter',
    faq: 'FAQ',
    admin: 'Admin',
    producer: 'Producent',
    cart: 'Kundvagn',
    checkout: 'Kassa',
    loading: 'Laddar...',
    accessDenied: 'Åtkomst nekad',
    noPermission: 'Du har inte behörighet att komma åt denna sida.',
    backToHome: 'Tillbaka till startsidan',
    profile: 'Profil',
    orders: 'Beställningar',
    updateProfileInfo: 'Uppdatera din personliga information',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    phone: 'Telefon',
    address: 'Adress',
    save: 'Spara',
    saving: 'Sparar...',
    changePassword: 'Ändra lösenord',
    updateYourPassword: 'Uppdatera ditt kontolösenord',
    newPassword: 'Nytt lösenord',
    confirmPassword: 'Bekräfta lösenord',
    updating: 'Uppdaterar...',
    updatePassword: 'Uppdatera lösenord',
    profileUpdated: 'Profilen uppdaterades',
    updateProfileError: 'Det uppstod ett fel vid uppdatering av din profil',
    passwordsDoNotMatch: 'Lösenorden matchar inte',
    passwordTooShort: 'Lösenordet måste vara minst 8 tecken',
    passwordUpdated: 'Lösenordet har uppdaterats',
    updatePasswordError: 'Det uppstod ett fel vid uppdatering av ditt lösenord',
    yourOrders: 'Dina beställningar',
    noOrders: 'Du har inga beställningar än',
    startShopping: 'Börja handla för att se din beställningshistorik',
    browseProducts: 'Bläddra bland produkter',
    orderNumber: 'Ordernummer',
    orderStatus: {
      pending: 'Väntar',
      processing: 'Behandlas',
      shipped: 'Skickad',
      delivered: 'Levererad',
      completed: 'Slutförd',
      cancelled: 'Avbruten'
    },
    quantity: 'Antal',
    total: 'Totalt',
    fetchOrdersError: 'Det gick inte att ladda beställningarna. Försök igen senare.'
  },
  home: {
    hero: {
      title: 'Färsk lokalproducerad mat, levererad direkt hem till dig',
      description: 'Stöd lokala producenter och njut av de färskaste råvarorna levererade direkt till dig. Från nyvärpta ägg av frigående höns till hantverksrökt bacon.',
      cta: 'Handla nu'
    },
    producers: {
      title: 'Möt våra producenter',
      viewAll: 'Se alla producenter'
    },
    categories: {
      title: 'Bläddra efter kategori',
      viewAll: 'Visa alla produkter'
    },
    howItWorks: {
      title: 'Hur det fungerar',
      steps: {
        order: {
          title: 'Välj dina produkter',
          description: 'Bläddra bland vårt urval av lokalt producerade varor från vårt nätverk av betrodda producenter.'
        },
        delivery: {
          title: 'Snabb leverans',
          description: 'Vi levererar din beställning direkt till din dörr och garanterar färskhet och kvalitet.'
        },
        enjoy: {
          title: 'Njut av färsk mat',
          description: 'Njut av läckra, färska och lokala produkter samtidigt som du stödjer ditt lokala samhälle.'
        }
      }
    }
  },
  products: {
    filter: 'Filtrera',
    sort: 'Sortera',
    search: 'Sök produkter...',
    noResults: 'Inga produkter hittades',
    addToCart: 'Lägg i kundvagn',
    viewMore: 'Visa mer',
    price: 'Pris',
    quantity: 'Antal',
    inStock: 'I lager',
    outOfStock: 'Slut i lager',
    description: 'Beskrivning',
    relatedProducts: 'Relaterade produkter',
    ingredients: 'Ingredienser',
    addIngredient: 'Lägg till',
    noIngredients: 'Inga ingredienser tillagda',
    ingredientsHint: 'Lägg till ingredienser som ingår i din produkt. Detta är viktigt för kunder med allergier.'
  },
  producers: {
    about: 'Om',
    products: 'Produkter',
    contact: 'Kontakt',
    location: 'Plats',
    noProducts: 'Denna producent har inga produkter ännu'
  },
  cart: {
    title: 'Kundvagn',
    empty: 'Din kundkorg är tom, klicka för att handla',
    continueShopping: 'Fortsätt handla',
    proceedToCheckout: 'Gå till kassan',
    summary: 'Ordersammanfattning',
    subtotal: 'Delsumma',
    shipping: 'Frakt',
    total: 'Totalt',
    remove: 'Ta bort',
    minimumOrderRequired: 'Minsta beställning på {amount} kr krävs',
    orderMore: 'Lägg till fler produkter för att gå till kassan'
  },
  checkout: {
    title: 'Kassa',
    contactInfo: 'Kontaktinformation',
    shippingAddress: 'Leveransadress',
    paymentMethod: 'Betalningsmetod',
    orderSummary: 'Ordersammanfattning',
    placeOrder: 'Lägg beställning',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    email: 'E-post',
    phone: 'Telefon',
    address: 'Adress',
    city: 'Stad',
    zipCode: 'Postnummer',
    country: 'Land',
    cardInfo: 'Kortinformation',
    cardNumber: 'Kortnummer',
    expiryDate: 'Utgångsdatum',
    cvv: 'CVV'
  },
  auth: {
    signIn: 'Logga in',
    register: 'Registrera',
    email: 'E-post',
    password: 'Lösenord',
    forgotPassword: 'Glömt lösenord?',
    noAccount: 'Har du inget konto?',
    createAccount: 'Skapa konto',
    alreadyHaveAccount: 'Har du redan ett konto?',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    confirmPassword: 'Bekräfta lösenord',
    resetPassword: 'Återställ lösenord',
    resetPasswordLink: 'Skicka återställningslänk'
  },
  admin: {
    overview: 'Översikt',
    orders: 'Beställningar',
    categories: 'Kategorier',
    producers: 'Producenter',
    faq: 'Vanliga frågor',
    emailTemplates: 'E-postmallar',
    contact: 'Kontakt',
    instructions: 'Instruktioner',
    deliverySlots: 'Leveranstider',
    settings: 'Inställningar'
  },
  producer: {
    products: 'Produkter',
    orders: 'Beställningar',
    profile: 'Profil',
    instructions: 'Instruktioner'
  }
}; 